import * as req from 'api/actions';
import * as c from './constant';

export const getTransactionList = (payload, callback) =>
  req.list(
    c.GET_TRANSACTION,
    'api/v1/administrators/sms_notifications',
    payload,
    callback
  );

export const showTransaction = (id, payload, callback) =>
  req.item(
    c.SHOW_TRANSACTION,
    `api/v1/administrators/sms_notifications/${id}`,
    payload,
    callback
  );

export const createSMSNotifications = (payload, callback) =>
  req.create(
    c.CREATE_SMS_NOTIFICATIONS,
    'api/v1/administrators/sms_notifications',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const resendSMSNotifications = (id, payload, callback) =>
  req.list(
    c.RESEND_SMS_NOTIFICATIONS,
    `api/v1/administrators/sms_notifications/${id}/send`,
    payload,
    callback
  );
